import { Injectable } from '@angular/core';
import { Http,RequestOptions,Headers } from '@angular/http';

@Injectable()
export class NotificationsProvider {
  headers: Headers;
  options: RequestOptions;
  constructor(public http: Http) {
    console.log('Hello NotificationsProvider Provider');
    this.headers = new Headers();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Authorization', 'key=AAAAAHp9v2w:APA91bGM_nL4iC6j72NRunMAoXJ-fhIUJcyRsHgmuDuFaSFShJy0TgBm79C9N0wZXEdzCai0svm98Kzz2bWbcwZzSvb6KEZNgP_X65svN3-h27w_7O3t-bwdYHwtqnR9y2cPzIiezsFk');
  }

  sendNotification(title,text)
  {
    let body = {
      "notification":{
        "title":title,
        "body":text,
        "sound":"default",
        "click_action":"FCM_PLUGIN_ACTIVITY",
        "icon":"fcm_push_icon"
      },
      "data":{},
      "to":"/topics/incidents",
      "priority":"high",
      "restricted_package_name":""
    }
    this.options = new RequestOptions({ headers: this.headers });

    this.http.post("https://fcm.googleapis.com/fcm/send",body,this.options)
      .subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/providers/notifications/notifications.ts